import React from 'react';
import { Link } from 'react-router-dom';

function AuthFormFooter({ text, linkTo, linkLabel }) {
  return (
    <p className="auth-footer-text">
      {text} <Link to={linkTo} className="auth-link">{linkLabel}</Link>
    </p>
  );
}

export default AuthFormFooter;
